import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";

const IMAGES = {
  heroBg: "/images/imageweb_1.jpg",
  svc1: "/images/imageweb_9.jpg",
  svc2: "/images/imageweb_5.jpg",
  svc3: "/images/imageweb_2.jpg",
  svc4: "/images/imageweb_7.jpg",
};
const IconAnyaman = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    width="26"
    height="26"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
    <path d="M8 12c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4z" />
    <path d="M12 8V5M12 19v-3M5 12H2M22 12h-3" />
  </svg>
);
const IconBatik = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    width="26"
    height="26"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M3 9h18M3 15h18M9 3v18M15 3v18" />
  </svg>
);
const IconKopi = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    width="26"
    height="26"
  >
    <path d="M17 8h1a4 4 0 0 1 0 8h-1" />
    <path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V8z" />
    <line x1="6" y1="2" x2="6" y2="4" />
    <line x1="10" y1="2" x2="10" y2="4" />
    <line x1="14" y1="2" x2="14" y2="4" />
  </svg>
);
const IconIkan = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    width="26"
    height="26"
  >
    <path d="M12 12c-2-2.5-4-3-7-3 0 4 2 7 7 7s7-3 7-7c-3 0-5 .5-7 3z" />
    <path d="M19 9l2-2-2-2" />
    <circle cx="9" cy="10" r="1" fill="currentColor" />
  </svg>
);

const SERVICES = [
  {
    id: 1,
    title: "Edukasi Anyaman",
    icon: <IconAnyaman />,
    img: IMAGES.svc1,
    desc: "Program Pelatihan Dan Pembinaan Kerajinan Anyaman Tradisional Untuk Masyarakat Desa. Kami Mengajarkan Berbagai Teknik Anyaman Yang Dapat Menghasilkan Produk Berkualitas Tinggi.",
    bullets: [
      "Pelatihan Intensif Selama 3 Bulan",
      "Bimbingan Dari Pengrajin Berpengalaman",
      "Sertifikat Kompetensi",
      "Bantuan Pemasaran Produk",
    ],
  },
  {
    id: 2,
    title: "Edukasi Batik",
    icon: <IconBatik />,
    img: IMAGES.svc2,
    desc: "Workshop Dan Pelatihan Membatik Tradisional Dengan Berbagai Motif Khas Daerah. Peserta Akan Belajar Dari Proses Pembuatan Pola Hingga Pewarnaan.",
    bullets: [
      "Workshop Mingguan",
      "Alat Dan Bahan Disediakan",
      "Teknik Batik Tulis Dan Cap",
      "Peluang Usaha Mandiri",
    ],
  },
  {
    id: 3,
    title: "Edukasi Kopi",
    icon: <IconKopi />,
    img: IMAGES.svc3,
    desc: "Pelatihan Budidaya Dan Pengolahan Kopi Lokal Mulai Dari Penanaman, Pemeliharaan, Panen, Hingga Pengolahan Biji Kopi Menjadi Produk Siap Konsumsi.",
    bullets: [
      "Pelatihan Budidaya Kopi",
      "Teknik Pengolahan Pasca Panen",
      "Pengemasan Dan Branding",
      "Akses Ke Pasar Kopi Lokal",
    ],
  },
  {
    id: 4,
    title: "Budidaya Ikan Mas Sinyonya",
    icon: <IconIkan />,
    img: IMAGES.svc4,
    desc: "Program Pembinaan Budidaya Ikan Mas Sinyonya Dengan Teknik Modern Yang Efisien Dan Ramah Lingkungan Untuk Meningkatkan Hasil Panen.",
    bullets: [
      "Teknik Budidaya Modern",
      "Manajemen Kualitas Air",
      "Pemilihan Berkualitas",
      "Jaringan Distribusi",
    ],
  },
];

export default function Services({ isAdmin, AdminSection }) {
  return (
    <div className="min-h-screen bg-white font-serif">
      <style>{`
        .page-hero {
          height: 420px; min-height: 320px;
          position: relative; display: flex;
          align-items: center; justify-content: center;
          background-size: cover; background-position: center;
          overflow: hidden;
        }
        .page-hero-overlay {
          position: absolute; inset: 0;
          background: linear-gradient(160deg,rgba(20,40,28,0.75) 0%,rgba(61,79,69,0.52) 60%,rgba(15,30,20,0.82) 100%);
        }
        .page-hero-content {
          position: relative; z-index: 10;
          text-align: center; padding: 64px 1.5rem 0;
          animation: pgFadeUp 0.9s ease 0.15s both;
        }
        @keyframes pgFadeUp {
          from { opacity:0; transform:translateY(24px); }
          to   { opacity:1; transform:translateY(0); }
        }

        /* Alternating service rows */
        .svc-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 3rem;
          align-items: center;
          padding: 3.5rem 0;
          border-bottom: 1px solid #f0f0f0;
        }
        .svc-row:last-child { border-bottom: none; }
        /* Even rows: image left, text right */
        .svc-row.even { direction: rtl; }
        .svc-row.even > * { direction: ltr; }

        .svc-icon-wrap {
          width: 52px; height: 52px;
          border-radius: 50%;
          background: #e8efe9;
          display: flex; align-items: center; justify-content: center;
          color: #3d4f45;
          margin-bottom: 1rem;
          flex-shrink: 0;
        }
        .svc-img {
          width: 100%; height: 300px;
          object-fit: cover;
          border-radius: 12px;
        }
        .svc-img-placeholder {
          width: 100%; height: 300px;
          background: #b8c5ba;
          border-radius: 12px;
        }
        .svc-bullet { font-size: .8rem; color: #4b5563; margin-bottom: .35rem; padding-left: .5rem; }
        .svc-bullet::before { content: "• "; color: #3d4f45; font-weight: bold; }

        @media (max-width: 768px) {
          .svc-row, .svc-row.even {
            grid-template-columns: 1fr;
            direction: ltr;
          }
          .svc-img, .svc-img-placeholder { height: 220px; }
        }
      `}</style>

      <Navbar />
      <WhatsAppButton />

      {/* HERO */}
      <section
        className="page-hero"
        style={{ backgroundImage: `url(${IMAGES.heroBg})` }}
      >
        <div className="page-hero-overlay" />
        <div className="page-hero-content">
          <p
            style={{
              fontSize: ".62rem",
              letterSpacing: ".32em",
              color: "#b8c5ba",
              textTransform: "uppercase",
              marginBottom: "1rem",
            }}
          >
            BUM Desa Warga Dekat Bandung
          </p>
          <h1
            style={{
              fontSize: "clamp(2rem,4.5vw,3.4rem)",
              color: "#fff",
              fontWeight: 300,
              lineHeight: 1.18,
              marginBottom: "1rem",
            }}
          >
            Layanan Kami
          </h1>
          <p
            style={{
              fontSize: ".87rem",
              color: "rgba(255,255,255,.82)",
              maxWidth: "520px",
              margin: "0 auto",
              lineHeight: 1.75,
            }}
          >
            Dari pertanian hingga pemberdayaan — kami hadir dengan layanan
            komprehensif untuk masyarakat desa.
          </p>
        </div>
      </section>

      {/* SERVICES — alternating layout */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-5xl mx-auto">
          {SERVICES.map((svc, idx) => (
            <div
              key={svc.id}
              className={`svc-row${idx % 2 === 1 ? " even" : ""}`}
            >
              {/* TEXT SIDE */}
              <div>
                <div className="svc-icon-wrap">{svc.icon}</div>
                <h3
                  style={{
                    fontSize: "1.05rem",
                    fontWeight: 600,
                    color: "#3d4f45",
                    marginBottom: ".6rem",
                  }}
                >
                  {svc.title}
                </h3>
                <p
                  style={{
                    fontSize: ".83rem",
                    color: "#6b7280",
                    lineHeight: 1.75,
                    marginBottom: "1rem",
                  }}
                >
                  {svc.desc}
                </p>
                <p
                  style={{
                    fontSize: ".75rem",
                    fontWeight: 600,
                    color: "#3d4f45",
                    marginBottom: ".5rem",
                  }}
                >
                  Keunggulan Program:
                </p>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {svc.bullets.map((b, i) => (
                    <li key={i} className="svc-bullet">
                      {b}
                    </li>
                  ))}
                </ul>
              </div>

              {/* IMAGE SIDE */}
              <div>
                <img
                  src={svc.img}
                  alt={svc.title}
                  className="svc-img"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "block";
                  }}
                />
                <div
                  className="svc-img-placeholder"
                  style={{ display: "none" }}
                />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-6 bg-[#f5f7f6]">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl mb-4 text-[#3d4f45] font-light">
            Tertarik Menggunakan Layanan Kami?
          </h2>
          <p className="text-gray-500 mb-8 text-sm leading-relaxed">
            Tim kami siap membantu Anda menemukan layanan yang paling sesuai
            dengan kebutuhan. Hubungi kami sekarang untuk konsultasi gratis.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-[#3d4f45] text-white px-8 py-3 rounded-full text-sm hover:bg-[#4a5a50] transition"
          >
            HUBUNGI KAMI
          </Link>
        </div>
      </section>

      {isAdmin && (
        <div className="max-w-6xl mx-auto px-6 pb-8">
          <hr className="my-8 border-gray-200" />
          <AdminSection />
        </div>
      )}
      <Footer />
    </div>
  );
}
